import { j as v } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
import { c as K, u as W, a as C } from "./index.stoqs9MZ.js";
import { u as I, a as J } from "./index.B4ZV02se.js";
import { D as Q } from "./index.DNGle7LJ.js";
import { u as Z } from "./index.BUG7NYeV.js";
import { c as M, A as ee, R as te, a as oe, C as re } from "./index.C27qk3BS.js";
import { P as ne } from "./index.TrmYLGk6.js";
import { P as se } from "./index.DMLWxr4u.js";
import { R as ae } from "./index.BkBvp-m6.js";
import { c as S } from "./index.CxSWpsOB.js";
var [O, He] = K("Tooltip", [
  M
]), D = M(), H = "TooltipProvider", ie = 700, L = "tooltip.open", [le, A] = O(H), G = (t) => {
  const {
    __scopeTooltip: o,
    delayDuration: e = ie,
    skipDelayDuration: r = 300,
    disableHoverableContent: n = !1,
    children: c
  } = t, i = s.useRef(!0), f = s.useRef(!1), a = s.useRef(0);
  return s.useEffect(() => {
    const p = a.current;
    return () => window.clearTimeout(p);
  }, []), /* @__PURE__ */ v.jsx(
    le,
    {
      scope: o,
      isOpenDelayedRef: i,
      delayDuration: e,
      onOpen: s.useCallback(() => {
        window.clearTimeout(a.current), i.current = !1;
      }, []),
      onClose: s.useCallback(() => {
        window.clearTimeout(a.current), a.current = window.setTimeout(
          () => i.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: f,
      onPointerInTransitChange: s.useCallback((p) => {
        f.current = p;
      }, []),
      disableHoverableContent: n,
      children: c
    }
  );
};
G.displayName = H;
var E = "Tooltip", [ce, _] = O(E), F = (t) => {
  const {
    __scopeTooltip: o,
    children: e,
    open: r,
    defaultOpen: n,
    onOpenChange: c,
    disableHoverableContent: i,
    delayDuration: f
  } = t, a = A(E, t.__scopeTooltip), p = D(o), [l, m] = s.useState(null), h = Z(), d = s.useRef(0), T = i ?? a.disableHoverableContent, u = f ?? a.delayDuration, x = s.useRef(!1), [g, w] = W({
    prop: r,
    defaultProp: n ?? !1,
    onChange: (N) => {
      N ? (a.onOpen(), document.dispatchEvent(new CustomEvent(L))) : a.onClose(), c?.(N);
    },
    caller: E
  }), b = s.useMemo(() => g ? x.current ? "delayed-open" : "instant-open" : "closed", [g]), P = s.useCallback(() => {
    window.clearTimeout(d.current), d.current = 0, x.current = !1, w(!0);
  }, [w]), R = s.useCallback(() => {
    window.clearTimeout(d.current), d.current = 0, w(!1);
  }, [w]), k = s.useCallback(() => {
    window.clearTimeout(d.current), d.current = window.setTimeout(() => {
      x.current = !0, w(!0), d.current = 0;
    }, u);
  }, [u, w]);
  return s.useEffect(() => () => {
    d.current && (window.clearTimeout(d.current), d.current = 0);
  }, []), /* @__PURE__ */ v.jsx(te, { ...p, children: /* @__PURE__ */ v.jsx(
    ce,
    {
      scope: o,
      contentId: h,
      open: g,
      stateAttribute: b,
      trigger: l,
      onTriggerChange: m,
      onTriggerEnter: s.useCallback(() => {
        a.isOpenDelayedRef.current ? k() : P();
      }, [a.isOpenDelayedRef, k, P]),
      onTriggerLeave: s.useCallback(() => {
        T ? R() : (window.clearTimeout(d.current), d.current = 0);
      }, [R, T]),
      onOpen: P,
      onClose: R,
      disableHoverableContent: T,
      children: e
    }
  ) });
};
F.displayName = E;
var j = "TooltipTrigger", B = s.forwardRef(
  (t, o) => {
    const { __scopeTooltip: e, ...r } = t, n = _(j, e), c = A(j, e), i = D(e), f = s.useRef(null), a = I(o, f, n.onTriggerChange), p = s.useRef(!1), l = s.useRef(!1), m = s.useCallback(() => p.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", m), [m]), /* @__PURE__ */ v.jsx(oe, { asChild: !0, ...i, children: /* @__PURE__ */ v.jsx(
      se.button,
      {
        "aria-describedby": n.open ? n.contentId : void 0,
        "data-state": n.stateAttribute,
        ...r,
        ref: a,
        onPointerMove: C(t.onPointerMove, (h) => {
          h.pointerType !== "touch" && !l.current && !c.isPointerInTransitRef.current && (n.onTriggerEnter(), l.current = !0);
        }),
        onPointerLeave: C(t.onPointerLeave, () => {
          n.onTriggerLeave(), l.current = !1;
        }),
        onPointerDown: C(t.onPointerDown, () => {
          n.open && n.onClose(), p.current = !0, document.addEventListener("pointerup", m, { once: !0 });
        }),
        onFocus: C(t.onFocus, () => {
          p.current || n.onOpen();
        }),
        onBlur: C(t.onBlur, n.onClose),
        onClick: C(t.onClick, n.onClose)
      }
    ) });
  }
);
B.displayName = j;
var ue = "TooltipPortal", [Ge, pe] = O(ue, {
  forceMount: void 0
}), y = "TooltipContent", U = s.forwardRef(
  (t, o) => {
    const e = pe(y, t.__scopeTooltip), { forceMount: r = e.forceMount, side: n = "top", ...c } = t, i = _(y, t.__scopeTooltip);
    return /* @__PURE__ */ v.jsx(ne, { present: r || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ v.jsx($, { side: n, ...c, ref: o }) : /* @__PURE__ */ v.jsx(de, { side: n, ...c, ref: o }) });
  }
), de = s.forwardRef((t, o) => {
  const e = _(y, t.__scopeTooltip), r = A(y, t.__scopeTooltip), n = s.useRef(null), c = I(o, n), [i, f] = s.useState(null), { trigger: a, onClose: p } = e, l = n.current, { onPointerInTransitChange: m } = r, h = s.useCallback(() => {
    f(null), m(!1);
  }, [m]), d = s.useCallback(
    (T, u) => {
      const x = T.currentTarget, g = { x: T.clientX, y: T.clientY }, w = he(g, x.getBoundingClientRect()), b = Te(g, w), P = xe(u.getBoundingClientRect()), R = ge([...b, ...P]);
      f(R), m(!0);
    },
    [m]
  );
  return s.useEffect(() => () => h(), [h]), s.useEffect(() => {
    if (a && l) {
      const T = (x) => d(x, l), u = (x) => d(x, a);
      return a.addEventListener("pointerleave", T), l.addEventListener("pointerleave", u), () => {
        a.removeEventListener("pointerleave", T), l.removeEventListener("pointerleave", u);
      };
    }
  }, [a, l, d, h]), s.useEffect(() => {
    if (i) {
      const T = (u) => {
        const x = u.target, g = { x: u.clientX, y: u.clientY }, w = a?.contains(x) || l?.contains(x), b = !we(g, i);
        w ? h() : b && (h(), p());
      };
      return document.addEventListener("pointermove", T), () => document.removeEventListener("pointermove", T);
    }
  }, [a, l, i, p, h]), /* @__PURE__ */ v.jsx($, { ...t, ref: c });
}), [fe, me] = O(E, { isInside: !1 }), ve = J("TooltipContent"), $ = s.forwardRef(
  (t, o) => {
    const {
      __scopeTooltip: e,
      children: r,
      "aria-label": n,
      onEscapeKeyDown: c,
      onPointerDownOutside: i,
      ...f
    } = t, a = _(y, e), p = D(e), { onClose: l } = a;
    return s.useEffect(() => (document.addEventListener(L, l), () => document.removeEventListener(L, l)), [l]), s.useEffect(() => {
      if (a.trigger) {
        const m = (h) => {
          h.target?.contains(a.trigger) && l();
        };
        return window.addEventListener("scroll", m, { capture: !0 }), () => window.removeEventListener("scroll", m, { capture: !0 });
      }
    }, [a.trigger, l]), /* @__PURE__ */ v.jsx(
      Q,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: c,
        onPointerDownOutside: i,
        onFocusOutside: (m) => m.preventDefault(),
        onDismiss: l,
        children: /* @__PURE__ */ v.jsxs(
          re,
          {
            "data-state": a.stateAttribute,
            ...p,
            ...f,
            ref: o,
            style: {
              ...f.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ v.jsx(ve, { children: r }),
              /* @__PURE__ */ v.jsx(fe, { scope: e, isInside: !0, children: /* @__PURE__ */ v.jsx(ae, { id: a.contentId, role: "tooltip", children: n || r }) })
            ]
          }
        )
      }
    );
  }
);
U.displayName = y;
var z = "TooltipArrow", V = s.forwardRef(
  (t, o) => {
    const { __scopeTooltip: e, ...r } = t, n = D(e);
    return me(
      z,
      e
    ).isInside ? null : /* @__PURE__ */ v.jsx(ee, { ...n, ...r, ref: o });
  }
);
V.displayName = z;
function he(t, o) {
  const e = Math.abs(o.top - t.y), r = Math.abs(o.bottom - t.y), n = Math.abs(o.right - t.x), c = Math.abs(o.left - t.x);
  switch (Math.min(e, r, n, c)) {
    case c:
      return "left";
    case n:
      return "right";
    case e:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Te(t, o, e = 5) {
  const r = [];
  switch (o) {
    case "top":
      r.push(
        { x: t.x - e, y: t.y + e },
        { x: t.x + e, y: t.y + e }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - e, y: t.y - e },
        { x: t.x + e, y: t.y - e }
      );
      break;
    case "left":
      r.push(
        { x: t.x + e, y: t.y - e },
        { x: t.x + e, y: t.y + e }
      );
      break;
    case "right":
      r.push(
        { x: t.x - e, y: t.y - e },
        { x: t.x - e, y: t.y + e }
      );
      break;
  }
  return r;
}
function xe(t) {
  const { top: o, right: e, bottom: r, left: n } = t;
  return [
    { x: n, y: o },
    { x: e, y: o },
    { x: e, y: r },
    { x: n, y: r }
  ];
}
function we(t, o) {
  const { x: e, y: r } = t;
  let n = !1;
  for (let c = 0, i = o.length - 1; c < o.length; i = c++) {
    const f = o[c], a = o[i], p = f.x, l = f.y, m = a.x, h = a.y;
    l > r != h > r && e < (m - p) * (r - l) / (h - l) + p && (n = !n);
  }
  return n;
}
function ge(t) {
  const o = t.slice();
  return o.sort((e, r) => e.x < r.x ? -1 : e.x > r.x ? 1 : e.y < r.y ? -1 : e.y > r.y ? 1 : 0), Ce(o);
}
function Ce(t) {
  if (t.length <= 1) return t.slice();
  const o = [];
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    for (; o.length >= 2; ) {
      const c = o[o.length - 1], i = o[o.length - 2];
      if ((c.x - i.x) * (n.y - i.y) >= (c.y - i.y) * (n.x - i.x)) o.pop();
      else break;
    }
    o.push(n);
  }
  o.pop();
  const e = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const n = t[r];
    for (; e.length >= 2; ) {
      const c = e[e.length - 1], i = e[e.length - 2];
      if ((c.x - i.x) * (n.y - i.y) >= (c.y - i.y) * (n.x - i.x)) e.pop();
      else break;
    }
    e.push(n);
  }
  return e.pop(), o.length === 1 && e.length === 1 && o[0].x === e[0].x && o[0].y === e[0].y ? o : o.concat(e);
}
var ye = G, be = F, Y = B, q = U, Pe = V;
const X = s.createContext(null), Re = ({
  children: t,
  open: o,
  onOpenChange: e,
  providerProps: r,
  rootProps: n
}) => {
  const [c, i] = s.useState(!1), f = o ?? c, a = e ?? i;
  return /* @__PURE__ */ v.jsx(X.Provider, { value: {
    open: f,
    setOpen: a
  }, children: /* @__PURE__ */ v.jsx(ye, { ...r || {}, children: /* @__PURE__ */ v.jsx(be, { ...n || {}, open: f, onOpenChange: a, children: t }) }) });
};
Re.displayName = "Tooltip";
const Ee = s.forwardRef(({
  className: t,
  sideOffset: o = 4,
  ...e
}, r) => /* @__PURE__ */ v.jsx(q, { ref: r, sideOffset: o, className: S("tw-z-50 tw-overflow-hidden tw-rounded-4 tw-bg-base-white tw-px-12 tw-py-8 tw-body-1 tw-shadow-md tw-animate-in tw-fade-in-0 tw-zoom-in-95 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95 data-[side=bottom]:tw-slide-in-from-top-8 data-[side=left]:tw-slide-in-from-right-8 data-[side=right]:tw-slide-in-from-left-8 data-[side=top]:tw-slide-in-from-bottom-8", t), ...e }));
Ee.displayName = q.displayName;
const Oe = s.forwardRef(({
  className: t,
  onClick: o,
  onPointerDown: e,
  onPointerUp: r,
  onPointerLeave: n,
  onPointerCancel: c,
  ...i
}, f) => {
  const a = s.useContext(X), p = s.useRef(null), l = s.useRef(!1);
  if (!a)
    throw new Error("TooltipTrigger must be used within a Tooltip component");
  const {
    setOpen: m
  } = a, h = () => window.matchMedia("(pointer: coarse)").matches, d = () => {
    p.current !== null && (window.clearTimeout(p.current), p.current = null);
  }, T = () => {
    d(), l.current && (m(!1), l.current = !1);
  };
  return /* @__PURE__ */ v.jsx(Y, { ref: f, className: S("tw-inline-block", t), ...i, onClick: (u) => {
    h() && l.current && (u.preventDefault(), l.current = !1), o?.(u);
  }, onPointerDown: (u) => {
    (u.pointerType === "touch" || h()) && (l.current = !1, d(), p.current = window.setTimeout(() => {
      l.current = !0, m(!0);
    }, 500)), e?.(u);
  }, onPointerUp: (u) => {
    T(), r?.(u);
  }, onPointerLeave: (u) => {
    T(), n?.(u);
  }, onPointerCancel: (u) => {
    T(), c?.(u);
  } });
});
Oe.displayName = Y.displayName;
const Fe = Pe;
export {
  Re as T,
  Fe as a,
  Ee as b,
  Oe as c
};
//# sourceMappingURL=Tooltip.CRVGSwNn.js.map
